import { render, staticRenderFns } from "./ImageModerationServer.vue?vue&type=template&id=7d8cd5a8&"
import script from "./ImageModerationServer.vue?vue&type=script&lang=js&"
export * from "./ImageModerationServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports